import script from "./EmergencySuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencySuccess.vue?vue&type=script&setup=true&lang=js"

import "./EmergencySuccess.vue?vue&type=style&index=0&id=5ff8b740&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff8b740"]])

export default __exports__